import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
  base: {
    color: 'fg.DEFAULT',
    bg: 'primary',
    // color: 'text.inverted',

    // borderRadius: 'md',
    // fontWeight: 'medium',
    // _focus: {
    //   boxShadow: '0 0 0 3px rgba(59,91,219, 0.6)',
    // },
  },

  // variants: {
  //   variant: {
  //     solid: {
  //       bg: { _light: 'primary.300', _dark: 'primary.700' },
  //       color: {_light: 'tertiary.500', _dark: 'tertiary.900'},
  //       _hover: { bg: { _light: 'primary.300', _dark: 'primary.700' } },
  //       _active: { bg: { _light: 'primary.500', _dark: 'primary.500' } },
  //       _disabled: {
  //         bg: { _light: 'gray.300', _dark: 'gray.700' },
  //         color: { _light: 'gray.500', _dark: 'gray.400' },
  //       },
  //     },
  //     outline: {
  //       border: '1px solid',
  //       borderColor: { _light: 'primary.300', _dark: 'primary.700' },
  //       color: { _light: 'tertiary.800', _dark: 'tertiary.200' },
  //       _hover: { bg: { _light: 'primary.50', _dark: 'gray.800' } },
  //       _active: { bg: { _light: 'primary.100', _dark: 'gray.700' } },
  //     },
  //     ghost: {
  //       bg: 'transparent',
  //       color: { _light: 'primary.600', _dark: 'primary.400' },
  //       _hover: { bg: { _light: 'primary.50', _dark: 'gray.800' } },
  //       _active: { bg: { _light: 'primary.100', _dark: 'gray.700' } },
  //     },
  //   },
  //   size: {
  //     md: {
  //       px: 4,
  //       py: 2,
  //       fontSize: 'md',
  //     },
  //     sm: {
  //       px: 3,
  //       py: 1.5,
  //       fontSize: 'sm',
  //     },
  //     lg: {
  //       px: 5,
  //       py: 3,
  //       fontSize: 'lg',
  //     },
  //   },
  // },
  // defaultVariants: {
  //   variant: 'solid',
  //   size: 'md',
  // },
});
